import { render, staticRenderFns } from "./BaseNotificationsMenu.vue?vue&type=template&id=1b99d12f&scoped=true&"
import script from "./BaseNotificationsMenu.vue?vue&type=script&lang=ts&"
export * from "./BaseNotificationsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BaseNotificationsMenu.vue?vue&type=style&index=0&id=1b99d12f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99d12f",
  null
  
)

export default component.exports